/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// $(document).ready(function(){
//   alert("hello");
//   $("#shipping-estimator-province").prop('selectedIndex', 1);
// });

// Wait for the DOM to fully load
document.addEventListener('DOMContentLoaded', function () {
  // Select the dropdown
  const selectState = document.getElementById('shipping-estimator-province');
  selectState.selectedIndex = 1; // Index starts at 0
  // Alternatively, you can use value
  // Set the desired value
  //selectElement.value = "option2";
});

document.addEventListener('DOMContentLoaded', function () {
  const accordionTitles = document.querySelectorAll('.accordion-title');
  const accordionContents = document.querySelectorAll('.accordion-content');

  // Initially hide all accordion contents
  accordionContents.forEach(function (content) {
    content.style.display = 'none';
  });

  accordionTitles.forEach(function (title) {
    title.addEventListener('click', function () {
      // Close other accordions
      accordionTitles.forEach(function (otherTitle) {
        if (otherTitle !== title) {
          otherTitle.classList.remove('open');
          otherTitle.nextElementSibling.style.display = 'none';
        }
      });

      // Toggle the clicked accordion
      const content = title.nextElementSibling;
      if (title.classList.contains('open')) {
        title.classList.remove('open');
        content.style.display = 'none';
      } else {
        title.classList.add('open');
        content.style.display = 'block';
      }
    });
  });
});

const SESSION_STORAGE_KEYS = {
  customKitchen: 'custom_kitchen_cabinets',
  customMirrors: 'custom_mirrors_form_data',
  customShowerScreens: 'custom_shower_screens_form_data',
  customVanityScreens: 'custom_vanity_screens_form_data',
};

const setCustomKitchenOptionArrayEntry = (category, value) => {
  const storedValues =
    getSessionStorage(SESSION_STORAGE_KEYS.customKitchen) || {};
  const oldValue = storedValues[category] || '';
  const closestDiv = document.getElementById(value).closest('.filter_head');
  const element = document.getElementById(value);

  if (!category || !value) return;

  if (oldValue && oldValue === value) {
    storedValues[category] = '';
    closestDiv.classList.remove('selected');
    element.classList.remove('selected');
  } else {
    storedValues[category] = value;
    if (oldValue) {
      document
        .getElementById(oldValue)
        .closest('.filter_head')
        .classList.remove('selected');
      document.getElementById(oldValue).classList.remove('selected');
    }
    element.classList.add('selected');
    closestDiv.classList.add('selected');
  }

  window.sessionStorage.setItem(
    SESSION_STORAGE_KEYS.customKitchen,
    JSON.stringify(storedValues)
  );
};

const toggleCustomVanitySectionAndSetOption = (section, category, value) => {
  const collectionContainer = document.querySelector(
    '[data-selected-collection]'
  );
  const prevSelectedCollection = collectionContainer.getAttribute(
    'data-selected-collection'
  );
  const sectionElement = document.querySelector(
    `[data-collection="${section}"]`
  );

  if (!sectionElement) return;

  if (prevSelectedCollection && prevSelectedCollection !== section) {
    document.querySelector(
      `[data-collection="${prevSelectedCollection}"]`
    ).style.display = 'none';
  }

  collectionContainer.setAttribute('data-selected-collection', section);

  if (
    sectionElement.style.display === 'none' ||
    sectionElement.style.display === ''
  ) {
    sectionElement.style.display = 'flex';
  } else {
    sectionElement.style.display = 'none';
  }

  setCustomVanityScreensOption(category, value);
};

const VANITY_MAX_STEPS_MAP = {
  'Floor Standing': 13,
  'Wall Hung': 13,
  'With Legs': 10,
  'Cabinet Only': 7,
}

const setCustomVanityScreensOption = (category, value) => {
  if (category === 'Collection' && value) {
    selectedCollection = value;
    MAX_STEP = VANITY_MAX_STEPS_MAP[value] || 13;
  }

  const storedValues =
    getSessionStorage(SESSION_STORAGE_KEYS.customVanityScreens) || {};
  if (!category || !value) return;
  storedValues[category] = value;
  window.sessionStorage.setItem(
    SESSION_STORAGE_KEYS.customVanityScreens,
    JSON.stringify(storedValues)
  );
};

const getSessionStorage = (key) =>
  JSON.parse(window.sessionStorage.getItem(key));
const clearSessionStorage = (key) => window.sessionStorage.removeItem(key);

function toggleDialog(data) {
  const dialog = document.querySelector('dialog');
  if (dialog.open) {
    dialog.close();
  } else {
    resetContactFields();
    setDialogValues(data);
    dialog.showModal();
  }
}

function resetContactFields () {
  const address = document.getElementById('contact-address');
  const phone = document.getElementById('contact-phone');
  if (address && phone) {
    const addressDefaultSpan = address.querySelector('span[data-preview]');
    const phoneDefaultSpan = phone.querySelector('span[data-preview]');
    const addressFullSpan = address.querySelector('span[data-full]');
    const phoneFullSpan = phone.querySelector('span[data-full]');
    if (addressDefaultSpan && phoneDefaultSpan && addressFullSpan && phoneFullSpan) {
      addressDefaultSpan.style.display = 'block';
      phoneDefaultSpan.style.display = 'block';
      addressFullSpan.style.display = 'none';
      phoneFullSpan.style.display = 'none';
      addressDefaultSpan.setAttribute('data-is-active', 'true');
      phoneDefaultSpan.setAttribute('data-is-active', 'true');
      addressFullSpan.setAttribute('data-is-active', 'false');
      phoneFullSpan.setAttribute('data-is-active', 'false');
    }
  }
}

function toggleViewField(element) {
  const defaultSpan = element.querySelector('span[data-preview]');
  const fullSpan = element.querySelector('span[data-full]');

  if (!defaultSpan || !fullSpan) return;

  if (defaultSpan.getAttribute('data-is-active') === 'true') {
    fullSpan.style.display = 'block';
    defaultSpan.style.display = 'none';
    defaultSpan.setAttribute('data-is-active', 'false');
    fullSpan.setAttribute('data-is-active', 'true');
  } else {
    fullSpan.style.display = 'none';
    defaultSpan.style.display = 'block';
    defaultSpan.setAttribute('data-is-active', 'true');
    fullSpan.setAttribute('data-is-active', 'false');
  }
}

function setDialogValues(data) {
  const logo = document.getElementById('partner-logo');
  logo.src = data.logo || '';
  logo.alt = data.name || `${data.name} Partner Logo`;
  document.getElementById('partner-name').innerText = data.name || '';
  document.getElementById('showcase-title').innerText =
    'About ' + (data.name || '');
  document.getElementById('showcase-description').innerText =
    data.description || '';
  document.getElementById('dialog_form-title').innerText =
    'Contact ' + (data.name || '');

  document.getElementById('badges').innerHTML =
    data.badges
      .split(',')
      .map((badge) => `<span class="badge">${badge.trim()}</span>`)
      .join('') || '';
  document.getElementById('member-since').innerText =
    'Member Since: ' + data.member_since || '';
  document
    .getElementById('contact-address')
    .querySelector('span[data-full]').innerText = data.address || '';
  document
    .getElementById('contact-phone')
    .querySelector('span[data-full]').innerText = data.phone || '';
  document.getElementById('partner-email').value = data.email || '';

  const inst = document.getElementById('instagram_social');
  const facebook = document.getElementById('facebook_social');
  const twitter = document.getElementById('twitter_social');
  const youtube = document.getElementById('youtube_social');
  const linkedin = document.getElementById('linkedin_social');
  const pinterest = document.getElementById('pinterest_social');

  if (data.instagram_link) {
    inst.style.display = 'inline-block';
    inst.href = data.instagram_link;
  } else {
    inst.style.display = 'none';
  }

  if (data.facebook_link) {
    facebook.style.display = 'inline-block';
    facebook.href = data.facebook_link;
  } else {
    facebook.style.display = 'none';
  }

  if (data.twitter_link) {
    twitter.style.display = 'inline-block';
    twitter.href = data.twitter_link;
  } else {
    twitter.style.display = 'none';
  }

  if (data.youtube_link) {
    youtube.style.display = 'inline-block';
    youtube.href = data.youtube_link;
  } else {
    youtube.style.display = 'none';
  }

  if (data.linkedin_link) {
    linkedin.style.display = 'inline-block';
    linkedin.href = data.linkedin_link;
  } else {
    linkedin.style.display = 'none';
  }

  if (data.pinterest_link) {
    pinterest.style.display = 'inline-block';
    pinterest.href = data.pinterest_link;
  } else {
    pinterest.style.display = 'none';
  }

  const showcaseContainer = document.getElementById('showcase-images');
  showcaseContainer.innerHTML = '';
  if (data.showcase_images && data.showcase_images.length > 0) {
    data.showcase_images.forEach((imgSrc, idx) => {
      if (imgSrc) {
        const divElement = document.createElement('div');
        const title = document.createElement('p');
        const oneliner = document.createElement('p');
        const imageElement = document.createElement('img');

        imageElement.src = imgSrc;
        imageElement.alt = `Showcase Image ${idx + 1}`;
        imageElement.style = 'width: 100%; height: 90%; object-fit: contain;';
        divElement.className = 'showcase_images-wrapper';
        title.innerText = data[`showcase_title_${idx + 1}`] || '';
        title.style.fontSize = '16px';
        title.style.fontWeight = 'bold';
        title.style.margin = '0px';
        oneliner.style.fontSize = '16px';
        oneliner.style.margin = '0px';
        oneliner.innerText = data[`showcase_oneliner_${idx + 1}`] || '';
        divElement.appendChild(title);
        divElement.appendChild(oneliner);
        divElement.appendChild(imageElement);
        showcaseContainer.appendChild(divElement);
      }
    });
  }
}